const PropTypes = require('prop-types');
const React = require('react');
const { SanitizedRender } = require('@reverbdotcom/discovery-ui');

const BumpDiagram = require('../../../../../images/products/bump-marketing-icon.svg');
const BumpViewsImgSrc = require('../../../../../images/products/bump-scale.svg');
const HideableSlider = require('./hideable_slider.jsx');

const BumpSetup = ({
  bidSlider,
  exampleBumpPercent,
  listingPrice,
  exampleSpend,
  isNewCondition,
  showMobileSlider,
  sliderToggle,
}) => (
  <div className="product-bump__wrapper">
    <div className="product-bump__overview-col">
      <div className="product-bump__overview-col__grid-wrap">
        <div className="product-bump__overview-col__grid-wrap__icon">
          <a href="/page/bump">
            <img src={BumpDiagram} alt={I18n.t('js.bump.setup.explanation.bumpIcon')} className="d-block width-100" />
          </a>
        </div>
        <div className="product-bump__overview-col__marketing-wrap">
          <h3 className="product-bump__overview-col__heading">
            {I18n.t('js.bump.setup.bumpHelpsSell')}
          </h3>
          <p className="product-bump__overview-col__subheading">
            <SanitizedRender
              html={
                  I18n.t('js.bump.setup.bumpHelpsSellSubheading', {
                  linkOpen: '<a href="/page/bump" target="_blank">',
                  linkClose: '</a>',
                })
              }
            />
          </p>
          <ol className="product-bump__overview-col__benefits-list">
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.one')}</span>
              {I18n.t('js.bump.setup.explanation.stepOne')}
            </li>
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.two')}</span>
              {I18n.t('js.bump.setup.explanation.stepTwo')}
            </li>
            <li className="product-bump__overview-col__benefits-list__item">
              <span>{I18n.t('js.bump.setup.explanation.three')}</span>
              {I18n.t('js.bump.setup.explanation.stepThree')}
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div className="product-bump__slider-col">
      <HideableSlider
        label={I18n.t('js.bump.setup.selectBumpTier')}
        sliderToggle={sliderToggle}
        showMobileSlider={showMobileSlider}
      >
        <h4 className="product-bump__slider-col__label">
          {I18n.t('js.bump.setup.pickBumpTier')}
        </h4>
        <div className="product-bump__views-scale">
          <img src={BumpViewsImgSrc} alt={I18n.t('js.bump.setup.bumpChart')} />
          <div className="product-bump__views-scale__more">{I18n.t('js.bump.setup.moreViews')}</div>
          <div className={
              `product-bump__views-scale__most-popular
                ${isNewCondition ?
                  ' product-bump__views-scale__most-popular--new' :
                  ' product-bump__views-scale__most-popular--used'
                }
              `
            }
          >
            {I18n.t('js.bump.setup.mostPopular')}
          </div>
          <div className="product-bump__views-scale__much-more">{I18n.t('js.bump.setup.manyMoreViews')}</div>
        </div>
        {bidSlider}
        <h4 className="bump-charges__heading">{I18n.t('js.bump.setup.example')}</h4>
        <p className="bump-charges__description">
          <SanitizedRender
            html={
                I18n.t('js.bump.setup.bumpChargesExplained', {
                exampleBumpPercent,
                listingPrice,
                exampleSpend,
              })
            }
          />
        </p>
      </HideableSlider>
    </div>
  </div>
);

BumpSetup.propTypes = {
  bidSlider: PropTypes.element.isRequired,
  exampleBumpPercent: PropTypes.string.isRequired,
  listingPrice: PropTypes.string.isRequired,
  exampleSpend: PropTypes.string.isRequired,
  isNewCondition: PropTypes.bool,
  showMobileSlider: PropTypes.bool,
  sliderToggle: PropTypes.func,
};

module.exports = BumpSetup;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_setup.jsx